export default __webpack_public_path__ + "static/media/stu.07825246.jpg";